var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { SlotController } from '../../controllers/slot-controller';
import { BlocksElement } from '../BlocksElement';
import styles from './card.styles';
/**
 * @slot header - The component header content
 * @slot default - The component default content
 * @slot footer - The component footer content
 * @csspart base - The component's base wrapper.
 * @csspart header-wrapper - The component's header wrapper.
 * @csspart part-header - The component's header slot.
 * @csspart body - The component's body content.
 * @csspart part-default - The component's default slot.
 * @csspart footer-wrapper - The component's footer wrapper.
 * @csspart part-footer - The component's footer slot.
 */
export class BlocksCard extends BlocksElement {
    constructor() {
        super(...arguments);
        this.slots = new SlotController(this, 'header', null, 'footer');
    }
    static { this.styles = styles; }
    render() {
        const componentClassNames = this.componentClassNames('cat-c-card', {
            'cat-c-card--bare': this.variant === 'bare',
            'cat-c-card--remove-padding': this.removePadding,
            'cat-c-card--has-header-slot': this.slots.hasSlotted('header'),
            'cat-c-card--has-footer-slot': this.slots.hasSlotted('footer')
        });
        if (this.href) {
            return html `
        <a part="base" href=${this.href} class="${componentClassNames}" style="${ifDefined(this.isAutoHeight ? 'height: auto;' : undefined)}">
          <div part="header-wrapper" class="cat-c-card__header"><slot part="part-header" name="header"></slot></div>

          <div
            part="body"
            class="cat-c-card__body"
            style="${ifDefined(this.bodyMaxHeight ? '--cat-text-passage-overflow: auto; --cat-text-passage-max-height: ' + this.bodyMaxHeight + ';' : undefined)}"
          >
            <slot part="part-default"></slot>
          </div>

          <div part="footer-wrapper" class="cat-c-card__footer"><slot part="part-footer" name="footer"></slot></div>
        </a>
      `;
        }
        else {
            return html `
        <div part="base" class="${componentClassNames}" style="${ifDefined(this.isAutoHeight ? 'height: auto;' : undefined)}">
          <div part="header-wrapper" class="cat-c-card__header"><slot part="part-header" name="header"></slot></div>
          <div
            part="body"
            class="cat-c-card__body"
            style="${ifDefined(this.bodyMaxHeight ? '--cat-text-passage-overflow: auto; --cat-text-passage-max-height: ' + this.bodyMaxHeight + ';' : undefined)}"
          >
            <slot part="part-default"></slot>
          </div>

          <div part="footer-wrapper" class="cat-c-card__footer"><slot part="part-footer" name="footer"></slot></div>
        </div>
      `;
        }
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], BlocksCard.prototype, "removePadding", void 0);
__decorate([
    property({ type: String, reflect: true })
], BlocksCard.prototype, "href", void 0);
__decorate([
    property({ type: String, reflect: true })
], BlocksCard.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BlocksCard.prototype, "isAutoHeight", void 0);
__decorate([
    property({ type: String, reflect: true })
], BlocksCard.prototype, "bodyMaxHeight", void 0);
if (customElements.get('cat-card') === undefined) {
    customElements.define('cat-card', BlocksCard);
}
